import React from 'react';

/**
 * Gitea's mark — a teacup — drawn in the icon library's style (24×24, 2px
 * stroke, currentColor) because lucide has no Gitea icon. Used for Gitea,
 * Forgejo and Codeberg accounts.
 */
export default function GiteaIcon({ size = 16 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M4 8h13v5a6 6 0 0 1-6 6h-1a6 6 0 0 1-6-6z" />
      <path d="M17 9h1.5a2.5 2.5 0 0 1 0 5H17" />
      <path d="M9 11.5v3.5" />
      <path d="M9 13l3-1.5" />
      <path d="M8 4c0 1 1 1 1 2M12 3c0 1 1 1 1 2" />
    </svg>
  );
}
